import { render, staticRenderFns } from "./Absence.vue?vue&type=template&id=e98b0776&"
import script from "./Absence.vue?vue&type=script&lang=js&"
export * from "./Absence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Absence.vue"
export default component.exports